import AddShoppingListModal from './AddShoppingListModal';

export default AddShoppingListModal;
